var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5625 4.1875C19.875 4.40625 20.0312 4.78125 19.9688 5.15625L17.9688 18.1562C17.9375 18.4688 17.75 18.7188 17.4688 18.875C17.2188 19.0312 16.875 19.0625 16.5938 18.9375L12.875 17.375L10.7188 19.6875C10.4375 20 10 20.0938 9.625 19.9375C9.25 19.8125 9 19.4375 9 19V16.4062C9 16.2812 9.03125 16.1562 9.125 16.0625L14.3438 10.3438C14.5312 10.1562 14.5312 9.84375 14.3438 9.65625C14.1562 9.46875 13.8438 9.46875 13.6562 9.65625L7.3125 15.2812L4.53125 13.9062C4.21875 13.75 4 13.4062 4 13.0312C3.96875 12.6875 4.15625 12.3438 4.5 12.1562L18.5 4.15625C18.8125 3.96875 19.25 3.96875 19.5625 4.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.33ee695d.svg";
export { ForwardRef as ReactComponent };